



import { Component, Prop, Vue, Provide } from 'vue-property-decorator';
import config from '@/api/params.config';
// let SCorpID: string = '';
// let AppId: string = '';
// switch (window.location.hostname) {
//     case 'ehr-wechat-vue.lunz.cn': 
//         SCorpID = config.WECHAT_CORPID_PROD;
//         AppId = config.MONTHSUMMARY_APPID_PROD;
//         break;
//     default:
//         SCorpID = config.WECHAT_CORPID_DEV;
//         AppId = config.MONTHSUMMARY_APPID_DEV;
//         break;
// }

declare const wx: any;

@Component({})
export default class WxLocation extends Vue {
  public $api: any;
//   public longitude: number = 120.43294; // 精度
//   public latitude: number = 36.14508; // 维度
  public longitude: number = 0; // 精度
  public latitude: number = 0; // 维度
  public speed: number = 0;
  public accuracy: any = null;

  public getConfigData() {
      const isWeixin = navigator.userAgent.toLowerCase().indexOf('wxwork') !== -1;
      if (!isWeixin) {
            this.$emit('error', {
                msg: '非企业微信环境，使用百度地图定位',
            });
            return;
      }
      const that = this;
      this.$api.handleGetToken('WeChatInterface/WeChatInterface/GetJsApiAuthModel', {
          url: encodeURIComponent(window.location.href.split('#')[0]),
          sCorpID: 1000006, // 暂时先写死
          appId: 'wx521922227e01c0ed', // 暂时先写死
      }, (success: any) => {
            wx.config({
                beta: true,
                debug: true,
                appId: 'wx521922227e01c0ed', // 暂时先写死
                timestamp: success.Data.timestamp,
                nonceStr: success.Data.noncestr,
                signature: success.Data.signature,
                jsApiList: ['getLocation'],
            });
            wx.ready(() => {
                that.getLocation();
            });
            wx.error((err: any) => {
                that.$emit('error', {
                    msg: '微信功能配置失败,使用百度地图定位',
                });
            });
      }, (error: any) => {
          that.$emit('error', {
            msg: '微信功能配置参数获取失败,使用百度地图定位',
          });
      });
  }

  public getLocation() {
    const that = this;
    wx.getLocation({
        type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
        success: (res: any) => {
            that.latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
            that.longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
            that.speed = res.speed; // 速度，以米/每秒计(企业微信App不支持speed参数，输出固定为0)
            that.accuracy = res.accuracy; // 位置精度
            that.$emit('init', {
                longitude: that.longitude,
                latitude: that.latitude,
            });
        },
        error: (err: any) => {
            that.$emit('error', {
                msg: '用户拒绝授权地理位置, 使用百度地图定位',
            });
        },
    });
  }

  private mounted() {
      this.getConfigData();
    // this.$emit('init', {
    //     longitude: this.longitude,
    //     latitude: this.latitude,
    // });
  }
}
